module.exports = __webpack_public_path__ + "img/5.1274ddbc.png";